// extracted by mini-css-extract-plugin
export default {"login-with-password-form":"styles_login-with-password-form__Yeq2t","login-with-password-form-footer":"styles_login-with-password-form-footer__Wg5sX"};